import { useLocalStorage } from "usehooks-ts";
import SpoilerOptions from "./shared/SpoilerOptions";
import { Language } from "./shared/Language";
import { PropsWithChildren } from "react";
import useLocalization from "./localization/useLocalization";
import isCrawler from "./utils/isCrawler";

export default function SpoilerWarning({ children }: PropsWithChildren) {
  const [spoilersOk, setSpoilersOk] = useLocalStorage("spoilersOk2", false, {
    serializer: String,
    deserializer: (value) => value == "true",
  });
  const { L } = useLocalization();

  return spoilersOk || isCrawler ? (
    children
  ) : (
    <div className="commoncontainer">
      <img src="/gameassets/sprExclam_1.png" />
      <h1>{L("notice.title")}</h1>
      <p>
        {L("notice.unofficial")}
        <br />
        {L("notice.wishes")}
        <br />
        {L("notice.spoilers")}
      </p>
      <SpoilerOptions />
      <br />
      <p>
        <button onClick={() => setSpoilersOk(true)}>
          {L("notice.confirm")}
        </button>
      </p>
      <Language />
    </div>
  );
}
